/* src/app/component/distributor-wallet/distributor-wallet.component.scss */
.wallet-container {
  width: 100%;
  margin: 0;
  padding: 32px;
  background-color: #FCFCFD;
}
.empty-state {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
  color: #bbb;
}
.para1 {
  font-size: 16px;
  font-weight: 600;
  color: #101828;
}
.para2 {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.col-2 {
  padding: 0px;
}
::ng-deep .p-input-icon-left > .p-inputtext {
  padding-left: 2.5rem;
}
.header {
  display: flex;
  justify-content: space-between;
}
.header h2 {
  margin: 0;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: #101828;
}
.header .p-button-warning {
  width: 185px;
  height: 40px;
  padding: 10px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border: none;
  align-items: center;
  justify-content: center;
}
.balance-card {
  background: #fff;
  border: 1px solid #EDEDED;
  padding: 24px 24px;
  border-radius: 11px;
  text-align: left;
  width: 170px;
  height: 96px;
  margin-bottom: 28px;
  margin-top: 40px;
  display: inline-block;
  min-width: 163px;
  max-width: 100%;
  height: auto;
}
.balance-card p {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: black;
  margin: 0px;
}
.balance-card h2 {
  margin: 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  color: #101828;
}
::ng-deep .p-datatable .date-time-cell div {
  line-height: 1.4;
}
::ng-deep .p-datatable .date-time-cell .time {
  font-size: 13px;
  color: #666;
  margin-top: 2px;
}
::ng-deep .p-calendar .p-inputtext {
  width: 200px;
}
.search {
  width: 235px;
}
::ng-deep .p-datatable {
  border: 1px solid #d1d5db;
  border-radius: 8px;
}
::ng-deep .p-datatable-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
}
::ng-deep .p-datatable .p-datatable-tbody > tr {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}
::ng-deep .p-datatable .p-datatable-tfoot > tr > td {
  border: none !important;
  border-radius: 8px !important;
  background-color: #fff;
  color: #344054;
  font-size: 12px;
}
::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  border-width: 0 0 1px 0;
  padding: 12px 24px;
  font-size: 14px;
  color: #475467;
  font-weight: 400;
  height: auto !important;
  word-break: break-word !important;
  width: 314px;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th {
  padding: 12px 24px;
  color: #475467;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px 8px 0px 0px;
  width: 314px;
}
::ng-deep th {
  border-radius: 8px 8px 0px 0px;
  padding: 12px 24px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #475467;
}
::ng-deep td {
  padding: 16px 24px;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th:first-child,
::ng-deep .p-datatable .p-datatable-tbody > tr > td:first-child {
  width: 400px !important;
}
td small {
  font-size: 14px;
  color: #101828;
  font-style: normal;
  font-weight: 500;
}
::ng-deep .pi-arrow-right {
  background-color: #ECFDF3;
  border-radius: 50%;
  color: #039855;
  font-size: 13px;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
::ng-deep .pi-arrow-left {
  background-color: #FEF3F2;
  border-radius: 50%;
  color: #D92D20;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-size: 13px;
}
:host ::ng-deep .p-inputtext {
  height: 36px !important;
}
button.p-paginate:disabled {
  opacity: 0.6;
}
.paginator-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.paginator-left {
  display: flex;
}
.paginator-right {
  font-size: 14px;
}
.paginator-left button {
  margin-right: 5px;
}
::ng-deep .p-paginator .p-paginator-current {
  margin: 0;
}
::ng-deep .p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next {
  margin: 0 5px;
}
::ng-deep .p-paginator button {
  background-color: #f4f6f8;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  color: #616161;
}
::ng-deep .p-paginator button:hover {
  background-color: #ddd;
}
.p-paginate {
  background-color: white;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  padding: 8px;
}
.footer {
  color: #344054;
  font-size: 14px;
  font-weight: 500;
}
::ng-deep .p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {
  padding: 12px 20px !important;
  background-color: white;
}
:host ::ng-deep .p-datatable .p-datatable-wrapper {
  overflow: hidden !important;
}
:host ::ng-deep .p-datepicker {
  transform-origin: top center !important;
  top: unset !important;
  bottom: auto !important;
  left: -100px !important;
  margin-top: 40px !important;
}
@media screen and (max-width: 1200px) {
  :host ::ng-deep .p-datepicker {
    transform-origin: top center !important;
    top: unset !important;
    bottom: auto !important;
    left: -160px !important;
    margin-top: 40px !important;
  }
}
/*# sourceMappingURL=distributor-wallet.component-BWDUX2VE.css.map */
